const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Chinese%20woman%20in%20her%2030s%2C%20warm%20smile%2C%20simple%20neutral%20background%2C%20soft%20natural%20lighting%2C%20clean%20and%20professional&width=120&height=120&seq=avatar-01&orientation=squarish',
    name: '影迷小张',
    time: '2小时前',
    content: '51电影网的票房追踪真的是全网最快！《封神第二部》刚破30亿我就收到推送了，比其他平台快了至少半小时。幕后花絮内容也超有料，那些片场故事太有意思了。',
    likes: 328,
    tag: '忠实读者',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Chinese%20man%20in%20his%2040s%2C%20friendly%20expression%2C%20simple%20background%2C%20soft%20studio%20lighting%2C%20clean%20composition&width=120&height=120&seq=avatar-02&orientation=squarish',
    name: '电影从业者老李',
    time: '5小时前',
    content: '作为业内人，51电影网的争议事件报道算是比较客观的了。不站队不炒作，还原事件原貌，这在现在的娱乐媒体环境里很难得。希望继续保持这种专业态度。',
    likes: 256,
    tag: '业内人士',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Chinese%20woman%2C%20creative%20style%2C%20warm%20expression%2C%20simple%20background%2C%20soft%20lighting%2C%20editorial%20photography&width=120&height=120&seq=avatar-03&orientation=squarish',
    name: '追剧少女阿琳',
    time: '8小时前',
    content: '每天必刷51电影网！明星动态更新特别快，那些八卦揭秘虽然不一定都信但看着真的很解压。排行榜也做得很好，选片看评分很方便。',
    likes: 189,
    tag: '活跃用户',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Chinese%20man%20with%20glasses%2C%20intellectual%20look%2C%20warm%20smile%2C%20simple%20background%2C%20soft%20studio%20lighting%2C%20clean%20editorial&width=120&height=120&seq=avatar-04&orientation=squarish',
    name: '影评人大刘',
    time: '12小时前',
    content: '关注的平台里51电影网的深度内容质量最高。独家揭秘专题每一篇都值得细读，《张艺谋争议新片幕后》那篇我反复看了三遍，信息量巨大。',
    likes: 142,
    tag: '专业影评人',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="bg-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-[960px] mx-auto">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 text-center mb-4">
            读者热评
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">
            听听影迷朋友们对51电影网的真实评价
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
            {comments.map((comment, i) => (
              <div
                key={i}
                className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70"
              >
                <div className="flex items-start gap-3 mb-3">
                  <div className="w-10 h-10 md:w-11 md:h-11 flex-shrink-0 rounded-full overflow-hidden bg-background-200">
                    <img
                      src={comment.avatar}
                      alt={comment.name}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-0.5">
                      <span className="text-sm font-semibold text-foreground-800">{comment.name}</span>
                      <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-[10px] font-medium">
                        {comment.tag}
                      </span>
                    </div>
                    <span className="text-xs text-foreground-400">{comment.time}</span>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  {comment.content}
                </p>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-heart-line"></i>
                  <span>{comment.likes}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}